module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/mkt/affiliate-program"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15283501!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/protocol/header.vue
// module id = 293
// module chunks = 2